import { LicenseInfo } from "@mui/x-license";

// The MUI X Pro license key is designed to be public so it's expected that the license key is hard-coded here.
LicenseInfo.setLicenseKey(
  "d76acc1cb12c3297d4cc101a438eeaa7Tz0xMDg1MzIsRT0xNzcyMDYzOTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=",
);
